<ng-template #loaderContent>
  <div class="loader-content flex--nogrow align-center">
    @if (title()) {
      <h2 class="font-heading-4">{{ title() | finLocalization }}</h2>
    }
    <div class="loader-spacer pr-medium-y">
      <div class="loader" [ngClass]="color()"></div>
    </div>
    @if (paragraph()) {
      <div class="loader-for font-body-1">{{ paragraph() | finLocalization }}</div>
    }
  </div>
</ng-template>

@switch (loaderType()) {
  <!-- CASE 1/5: FULL_SCREEN -->
  @case (LoaderTheme.FULL_SCREEN) {
    <div class="loader-container fixed z5 top-left fill grow">
      <div class="loader-wrapper grid-max-width center grow flex flex--center nordic-blue-900-text white-bg">
        <ng-container *ngTemplateOutlet="loaderContent" />
      </div>
    </div>
  }

  <!-- CASE 2/5: EMBEDDED -->
  @case (LoaderTheme.EMBEDDED) {
    <div class="nordic-blue-900-text pr-large-y">
      <ng-container *ngTemplateOutlet="loaderContent" />
    </div>
  }

  <!-- CASE 3/5: INLINE -->
  @case (LoaderTheme.INLINE) {
    <div class="font-body-1">
      <div class="loader" [ngClass]="color()"></div>
    </div>
  }

  <!-- CASE 4/5: INLINE_TEXT -->
  @case (LoaderTheme.INLINE_TEXT) {
    <div class="font-body-1 inline-block pr-small-x">
      <div class="loader" [ngClass]="color()"></div>
    </div>
  }

  <!-- CASE 5/5: BUTTON -->
  @case (LoaderTheme.BUTTON) {
    <div class="font-body-1 inline-block pr-small-x">
      <div class="loader button-loader"></div>
    </div>
  }
}
